import React from "react";
import { Container, makeStyles, Typography } from "@material-ui/core";
import { theme } from "../constants/theme";

export const NewOrderDialog = ({ visible, tabName, onClick }) => {
  const classes = useStyles();

  if (!visible) {
    return <></>;
  }
  return (
    <div className={classes.root} onClick={onClick}>
      <Container className={classes.titleContainer}>
        <Typography
          variant="subtitle1"
          component="span"
          className={classes.title}
        >
          {`New ${tabName} order`}
        </Typography>
      </Container>
      <Container className={classes.bodyContainer}>
        <Typography variant="body2" component="span" className={classes.body}>
          {`You have received a new ${tabName} order, click here to refresh the list.`}
        </Typography>
      </Container>
    </div>
  );
};

const useStyles = makeStyles({
  root: {
    position: "fixed",
    paddingTop: "16px",
    paddingBottom: "16px",
    backgroundColor: theme.palette.primary.main,
    maxWidth: 840,
    width: 840,
    borderRadius: "20px",

    boxShadow:
      " 0px 8px 10px rgba(0, 0, 0, 0.2), 0px 16px 24px rgba(0, 0, 0, 0.14), 0px 6px 30px rgba(0, 0, 0, 0.12)",
    "&:hover, &:focus": {
      backgroundColor: "#A6146A",
      transition: "background-color 300ms linear",
    },
    "&:active": {
      backgroundColor: "#B53D84",
      transition: "background-color 300ms linear",
    },
    cursor: "pointer",
  },
  titleContainer: {
    marginBottom: 4,
  },
  bodyContainer: {
    //
  },
  title: {
    color: "rgba(255, 255, 255, 1)",
  },
  body: {
    color: "rgba(255, 255, 255, 1)",
  },
});
